import React from "react";
import { ProductConsumer } from "../../../../Context/AddProWakel";
import Time from "react-time-format";
import "../rent.css";

const Header = () => {
    return (
        <>
            <ProductConsumer>
                {(value) => {
                    const {
                        IT_phone,
                        IT_name,
                        IT_code,
                        IT_no_invoice,
                        IT_joripara,
                        IT_date,
                    } = value;
                    return (
                        <>
                            <form
                                className="border border-black "
                                style={{ borderTop: "1px solid black" }}
                            >
                                <div className="detail">
                                    <div className="row text-dark font-weight-bold f4 mt-2 border border-black">
                                        <div className="col-3 text-right form-inline mt-2">
                                            <p>
                                                <Time
                                                    value={IT_date}
                                                    format="YYYY-MM-DD"
                                                    style={{ color: "black" }}
                                                />
                                            </p>
                                        </div>
                                        <div className="col-3 text-right form-inline">
                                            <div className="form-group">
                                                <h5 className=" f4 mt-2" style={{ color: "black" }}>
                                                    {IT_phone}
                                                </h5>
                                                <label
                                                    className="font-weight-bold f4 ml3"
                                                    style={{ color: "black" }}
                                                >
                                                    :هاتف
                                                </label>
                                            </div>
                                        </div>

                                        <div className="col-3 text-right  form-inline ">
                                            <div className="form-group">
                                                <h5 className=" ml5 f4 mt-2" style={{ color: "black" }}>
                                                    {IT_name}
                                                </h5>
                                                <label
                                                    className="font-weight-bold f4 ml1"
                                                    style={{ color: "black" }}
                                                >
                                                    :اسم
                                                </label>
                                            </div>
                                        </div>

                                        <div className="col-3 text-right form-inline">
                                            <div className="form-group ">
                                                <h5 className=" ml5 f4 mt-2" style={{ color: "black" }}>
                                                    {IT_code}
                                                </h5>
                                                <label
                                                    className="font-weight-bold f4 ml3"
                                                    style={{ color: "black" }}
                                                >
                                                    :رقم المعمیل
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* row 2 */}
                                <hr style={{ border: "0.3px solid black" }} />
                                <div className="row text-dark font-weight-bold f4  mr-4 border border-black">
                                    <div className="col-3 text-right form-inline mb-2">
                                        <p>
                                            <Time
                                                value={IT_date}
                                                format="hh:mm:ss"
                                                style={{ color: "black" }}
                                            />
                                        </p>
                                    </div>
                                    <div className="col-3 text-right form-inline ">
                                        <div className="form-group ml3">
                                            <h5 className=" f4" style={{ color: "black" }}>
                                                {"ساحب المحل"}
                                            </h5>
                                            <label
                                                className="font-weight-bold mb-2 f4 ml3"
                                                style={{ color: "black" }}
                                            >
                                                : اسم مستسلم
                                            </label>
                                        </div>
                                    </div>

                                    <div className="col-3 text-right  form-inline">
                                        <div className="form-group ">
                                            <h5 className=" ml5 f4" style={{ color: "black" }}>
                                                {IT_joripara}
                                            </h5>
                                            <label
                                                className="font-weight-bold mb-2 f4 ml1 "
                                                style={{ color: "black" }}
                                            >
                                                : عملة
                                            </label>
                                        </div>
                                    </div>
                                    <div className="col-3 text-right form-inline">
                                        <div className="form-group ">
                                            <h5 className=" ml5 f4" style={{ color: "black" }}>
                                                {IT_no_invoice}
                                            </h5>
                                            <label
                                                className="font-weight-bold mb-2 f4 ml3"
                                                style={{ color: "black" }}
                                            >
                                                : رقم وصل
                                            </label>
                                        </div>
                                    </div>
                                </div>

                                <div></div>
                            </form>
                        </>
                    );
                }}
            </ProductConsumer>
        </>
    );
};

export default Header;
